"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogStruct = void 0;
var superstruct_1 = require("superstruct");
var Timestamp_1 = require("./Timestamp");
var UpdatedBy_1 = require("./UpdatedBy");
exports.LogStruct = (0, superstruct_1.type)({
    updatedBy: UpdatedBy_1.UpdatedByStruct,
    createdAt: Timestamp_1.TimestampStruct,
    isAnonymized: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
});
